import {Step, StepLabel, StepConnector, Typography, StepIconProps} from '@mui/material';
import Stepper from '@mui/material/Stepper';
import {Home, Person, PlaylistAddCheck, CheckCircle} from '@mui/icons-material';
import clsx from 'clsx';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import theme, {themeColors} from '../../theme/Theme';

const classes = {
  stepper: {
    padding: theme.spacing(0.2),
    paddingBottom: theme.spacing(0),
  },

  step: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },

  active: {
    backgroundColor: theme.palette.primary.main,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },

  completed: {
    backgroundColor: themeColors.green,
  },

  error: {
    backgroundColor: themeColors.red,
  },

  container: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: (theme as any).spacing(1),
  },
  line: {},
  alternativeLabel: {},
};

const ColorlibStepIcon: (step: addAccountStep) => React.FC<{
  active: boolean;
  completed: boolean;
  error: boolean;
  icon: number;
}> = (step) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  const {active, completed, error} = props;

  const icons: Record<addAccountStep, React.ReactNode> = {
    basic: <Person />,
    address: <Home />,
    summary: <PlaylistAddCheck />,
    setup: <CheckCircle />,
  };

  return (
    <div
      style={{
        ...classes.step,
        ...(active ? classes.active : {}),
        ...(completed && !active ? classes.completed : {}),
        ...(error ? classes.error : {}),
      }}
    >
      {icons[step]}
    </div>
  );
};

export type addAccountStep = 'basic' | 'address' | 'summary' | 'setup';

const initialAddAccountSteps: addAccountStep[] = ['basic', 'address', 'summary', 'setup'];

export const AddAccountStepper: React.FC<{currentStep: addAccountStep}> = ({
  currentStep,
}) => {
  const navigate = useNavigate();
  const index = initialAddAccountSteps.indexOf(currentStep);
  const getStepUrl = (leadStep: addAccountStep) => {
    return `./${leadStep}`;
  };
  return (
    <>
      <Stepper
        sx={{...classes.stepper, background: 'none'}}
        nonLinear
        alternativeLabel
        orientation="horizontal"
        activeStep={index}
        connector={
          <ColorlibConnector
            classes={{
              alternativeLabel: clsx(classes.alternativeLabel),
              active: clsx(classes.active),
              completed: clsx(classes.completed),
              line: clsx(classes.line),
            }}
            sx={{top: '18px'}}
          />
        }
      >
        {initialAddAccountSteps.map((step, _index) => {
          const completed = true;
          const beforeCurrentStep = _index < index;
          return (
            <Step
              completed={beforeCurrentStep}
              key={step}
              onClick={(e) => {
                if (process.env.NODE_ENV === 'development' || e.altKey) {
                  navigate({pathname: `${getStepUrl(step)}`});
                }
              }}
            >
              <StepLabel
                StepIconComponent={
                  ColorlibStepIcon(step) as React.ElementType<StepIconProps>
                }
                style={{
                  textTransform: 'capitalize',
                }}
                error={!completed && beforeCurrentStep}
              >
                <Typography
                  style={{top: -10, position: 'relative', fontWeight: 'bold'}}
                  color="primary"
                >
                  {step}
                </Typography>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </>
  );
};

const ColorlibConnector = StepConnector;
